export default __webpack_public_path__ + "static/media/watchdog-8.9d5ab74f.png";